export default __webpack_public_path__ + "img/healthcare_logo.jpg";